export default {

    formatDateTime(date) {
        if (date === null) return '';
        date = new Date(date);
        return date.getDate().toString().padStart(2, "0") + "." + date.getMonth().toString().padStart(2, "0") + "." + date.getFullYear() + " " + date.getHours().toString().padStart(2, "0") + ":" + date.getMinutes().toString().padStart(2, "0")
    }

}